/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Gallery {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { CartePlus as CartePlusModule } from "@bw/modules"
// parse is used to ensure that HTML sent by the CMS is converted to React components
import parse from "html-react-parser"
import { useStaticQuery, graphql } from "gatsby"

const Carteplus = () => {
  const { carteplus } = useStaticQuery(
    graphql`
      query cartePlusQuery {
        carteplus: globals(handle: { eq: "carteplus" }) {
          image {
            url
          }
          title
          text
          orderPage
        }
      }
    `
  )

  return (
    <CartePlusModule
      title={carteplus.title}
      text={carteplus?.text ? parse(carteplus.text) : undefined}
      image={carteplus.image.url}
      url={carteplus?.orderPage}
    />
  )
}

export { Carteplus }
